import { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";

import SmartImageUploader from "../../../../smartImageUploader/SmartImageUploader";

import classes from "./lotDetailForm.module.css";
import { FormInput } from "../../../../shared/formElements/formInput/FormInput";
import { FormDynamicStringList } from "../../../../shared/formElements/formDynamicStringList/FormDynamicStringList";
import { FormDynamicKeyValueList } from "../../../../shared/formElements/formDynamicKeyValueList/FormDynamicKeyValueList";
import { ProductImages } from "../../../../productImages/ProductImages";

export const LotDetailForm = ({
  initialValues,
  onSubmit,
  onApprove,
  isSubmitting,
}) => {
  /* =====================
     NORMALIZE API → FORM
  ===================== */
  const normalizedInitialValues = useMemo(() => {
    return {
      ...initialValues,
      images: Array.isArray(initialValues?.images)
        ? initialValues.images.map((img) => img.image_url)
        : [],
    };
  }, [initialValues]);

  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    watch,
    formState: { isValid, errors },
  } = useForm({
    defaultValues: normalizedInitialValues,
    mode: "onChange",
  });

  useEffect(() => {
    reset(normalizedInitialValues);
  }, [normalizedInitialValues, reset]);

  /* =====================
     SUBMIT → API SHAPE
  ===================== */
  const handleFormSubmit = (data) => {
    const payload = {
      ...data,
      images: Array.isArray(data.images)
        ? data.images.map((url) => ({
            image_url: url,
          }))
        : [],
    };

    onSubmit(payload);
  };

  return (
    <form className={classes.form} onSubmit={handleSubmit(handleFormSubmit)}>
      {/* =====================
          SELLER INFO
      ===================== */}
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Product Information</h3>
        <div className={classes.grid}>
          <FormInput
            id="part"
            label="Part Name"
            register={register}
            required={true}
            disabled
            validation={{ required: "Part Name is required" }}
            error={errors.part?.message}
          />
          <FormInput
            id="brand"
            label="Brand"
            register={register}
            required={true}
            disabled
            validation={{ required: true }}
            error={errors.brand?.message}
          />
        </div>
        <div className={classes.grid}>
          <FormInput
            id="model"
            label="Model"
            register={register}
            required={true}
            disabled
            validation={{ required: true }}
            error={errors.model?.message}
          />
          
          <FormInput
            id="color"
            label="Color"
            register={register}
            required={true}
            disabled
            validation={{ required: true }}
            error={errors.color?.message}
          />
        </div>
      </div>

      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Product Pricing</h3>
        <div className={classes.grid}>
          <FormInput
            id="original_price"
            label="Original Price"
            register={register}
            required={true}
            disabled
            validation={{ required: true }}
            error={errors.original_price?.message}
          />
          <FormInput
            id="discounted_price"
            label="Discounted Price"
            register={register}
            required={true}
            disabled
            validation={{ required: true }}
            error={errors.discounted_price?.message}
          />
        </div>
        <div className={classes.grid}>
          <FormInput
            id="discount_percentage"
            label="Discount Percentage"
            register={register}
            required={true}
            disabled
            validation={{ required: true }}
            error={errors.discount_percentage?.message}
          />
          <FormInput
            id="quantity"
            label="Quantity"
            register={register}
            required={true}
            disabled
            validation={{ required: true }}
            error={errors.quantity?.message}
          />
        </div>
      </div>

      {/* =====================
          IMAGES
      ===================== */}
      <div className={classes.section}>
        {/* <h3 className={classes.sectionTitle}>Images</h3> */}
        {/* <SmartImageUploader
          fieldName="images"
          control={control}
          setValue={setValue}
        /> */}
        <ProductImages
          images={initialValues?.images || []}
          productName={initialValues?.part}
        />
        
      </div>
      
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Highlights</h3>
        <FormDynamicStringList
          register={register}
          watch={watch}
          setValue={setValue}
          required={true}
          fieldName="highlights"
          control={control}
          disabled={true}
          errors={errors.highlights}
        />
      </div>
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>About This Item</h3>
        <FormDynamicStringList
          register={register}
          watch={watch}
          setValue={setValue}
          required={true}
          fieldName="about_this_item"
          control={control}
          disabled={true}
          errors={errors.about_this_item}
        />
      </div>

      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Product Details</h3>
        <FormDynamicStringList
          register={register}
          required={true}
          watch={watch}
          setValue={setValue}
          fieldName="product_details"
          control={control}
          disabled={true}
          errors={errors.product_details}
        />
      </div>

      {/* -------------------- KEY-VALUE LISTS -------------------- */}
      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>Specifications</h3>
        <FormDynamicKeyValueList
          register={register}
          required={true}
          watch={watch}
          setValue={setValue}
          fieldName="specifications"
          control={control}
          disabled={true}
          errors={errors.specifications}
        />
      </div>

      <div className={classes.section}>
        <h3 className={classes.sectionTitle}>FAQs</h3>
        <FormDynamicKeyValueList
          register={register}
          required={true}
          watch={watch}
          setValue={setValue}
          fieldName="FAQs"
          control={control}
          disabled={true}
          errors={errors.FAQs}
        />
      </div>

      {/* =====================
          ACTIONS
      ===================== */}
      {/* <div className={classes.actions}>
        <button
          type="submit"
          className={classes.submitBtn}
          disabled={isSubmitting || !isValid}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>
      </div> */}
    </form>
  );
};
